import { render, staticRenderFns } from "./ParameterRecordDialog.vue?vue&type=template&id=584bd625&scoped=true&"
import script from "./ParameterRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ParameterRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584bd625",
  null
  
)

export default component.exports